export const services = {
  albumProvider: Symbol('albumProvider'),
  experiments: Symbol('experiments'),
  siteInfo: Symbol('siteInfo'),
  siteSettings: Symbol('siteSettings'),
  location: Symbol('location'),
  wixPubSub: Symbol('wixPubSub'),
  imageUtils: Symbol('imageUtils'),
  Player: Symbol('Player'),
  mediaPlatformApi: Symbol('mediaPlatformApi'),
};
